// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Top[data-v-9bf2ed56] {\n  display: flex;\n  height: 0.6rem;\n  background: white;\n  border-radius: 0.1rem;\n  padding: 0 0.3rem;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 0.12rem;\n}\n.Top .current[data-v-9bf2ed56] {\n    margin-right: 0.24rem;\n    cursor: pointer;\n}\n.Top .checkTab[data-v-9bf2ed56] {\n    color: #2B2B2F;\n    font-size: 18px;\n    font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
